import {WebflowEnvironments} from '@packages/systems/core-constants';
import {collectionSlug as formatCollectionSlug} from '@packages/systems/dynamo/utils/SlugUtils';
import type {
  PageQuerySpecification,
  RuntimeInfo,
  QueryPath,
} from '@packages/systems/dynamo/source-types';

export function createCollectionTemplatePageQuerySpecification(
  collectionSlug: string
): PageQuerySpecification {
  const gqlCollectionField = formatCollectionSlug(collectionSlug);
  return {
    queryPathPrefix(runtimeInfo: RuntimeInfo): QueryPath {
      const localeArg = runtimeInfo.cmsLocaleId
        ? `, locale: "${runtimeInfo.cmsLocaleId}"`
        : '';

      switch (runtimeInfo.environment) {
        case WebflowEnvironments.SSR: {
          return [
            `cms(publication: "${runtimeInfo.publicationId}")`,
            `${gqlCollectionField}: collection(slug: "${collectionSlug}")`,
            `item(slug: $itemSlug${localeArg})`,
          ];
        }
        case WebflowEnvironments.DESIGNER: {
          return [
            'cms(staging: true)',
            `${gqlCollectionField}: collection(slug: "${collectionSlug}")`,
            `item(id: $itemId${localeArg})`,
          ];
        }
        default: {
          return [];
        }
      }
    },
  };
}
